import React from 'react';
import { object } from 'prop-types';
import { Page } from '@fiverr-private/perseus';
import { CMSContextProvider } from '@fiverr-private/cms_ui';

import { PAGE_NAME } from '../constants';
import App from '../App';

class ContentLandingPageApp extends Page {
    render() {
        const {
            data,
            context,
            placeholders,
            currentUser,
            currency,
            currencyObj
        } = this.props;

        return (
            <CMSContextProvider value={{ additionalProps: data.additionalProps, currencyObj, pageInfo: data.pageInfo }} pageName={PAGE_NAME}>
                <App {...data}
                    currentUser={currentUser}
                    context={context}
                    currency={currency}
                    placeholders={placeholders}/>
            </CMSContextProvider>
        );
    }
}

ContentLandingPageApp.propTypes = {
    data: object,
    context: object,
    placeholders: object,
    currency: object
};

export default ContentLandingPageApp;
